// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function execute(json) {
  return {
          login_banner_title: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_login_activity_content",
                      tl: {
                        hd: "login_banner_title",
                        tl: /* [] */0
                      }
                    }
                  }
                }, Json_decode.string)(json),
          description_one: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_login_activity_content",
                      tl: {
                        hd: "description_one",
                        tl: /* [] */0
                      }
                    }
                  }
                }, Json_decode.string)(json),
          description_bold: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_login_activity_content",
                      tl: {
                        hd: "description_bold",
                        tl: /* [] */0
                      }
                    }
                  }
                }, Json_decode.string)(json),
          tips_title: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_login_activity_content",
                      tl: {
                        hd: "tips_title",
                        tl: /* [] */0
                      }
                    }
                  }
                }, Json_decode.string)(json),
          description_pointers: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_login_activity_content",
                      tl: {
                        hd: "description_pointers",
                        tl: /* [] */0
                      }
                    }
                  }
                }, Json_decode.string)(json)
        };
}

export {
  execute ,
  
}
/* No side effect */
